






















































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import {
  CREATE_FORM_ERRORS,
  CREATE_FORM_LOADING,
  CREATE_NEW_FORM,
  OPEN_CHANGES_NOTIFICATION_MODAL,
  OPEN_CHOOSE_FORM_OFFICE_MODAL,
  REINIT_AUTHENTICATION_TOKEN,
  SET_CREATE_FORM_ERRORS,
  SET_CREATE_FORM_LOADING,
  SET_OPEN_CHANGES_NOTIFICATION_MODAL,
  SET_OPEN_CHOOSE_FORM_OFFICE_MODAL,
  UPDATE_USER_OFFICE,
} from '@/types/form.types';
import { USER_DETAILS } from '@/types/authentication.types';
import { UserDetails } from '@/models/UserDetails.model';
import ChangesNotification from '@/components/modals/ChangesNotification.modal.vue';
import {
  GET_CHANGES_NOTIFICATION_FLAG,
  OPEN_POPUP_CHANGES_NOTIFICATION_FLAG,
} from '@/types/lobby.types';

@Component({
  components: { ChangesNotification },
})
export default class ChooseFormOfficeModal extends Vue {

  @Inject() public $validator;

  @Action(CREATE_NEW_FORM, StoreNamespace.FORM) public createNewForm;
  @Action(UPDATE_USER_OFFICE, StoreNamespace.FORM) public updateUserOffice;
  @Action(REINIT_AUTHENTICATION_TOKEN, StoreNamespace.FORM) public reinitAuthenticationToken;
  @Action(GET_CHANGES_NOTIFICATION_FLAG, StoreNamespace.LOBBY) public getChangesNotificationFlag;

  @Mutation(SET_OPEN_CHOOSE_FORM_OFFICE_MODAL, StoreNamespace.FORM) public setOpenChooseFormOfficeModal;
  @Mutation(SET_CREATE_FORM_ERRORS, StoreNamespace.FORM) public setCreateFormErrors;
  @Mutation(SET_CREATE_FORM_LOADING, StoreNamespace.FORM) public setCreateFormLoading;
  @Mutation(SET_OPEN_CHANGES_NOTIFICATION_MODAL, StoreNamespace.FORM) public setOpenChangesNotificationModal;

  @Getter(OPEN_CHOOSE_FORM_OFFICE_MODAL, StoreNamespace.FORM) public openChooseFormOfficeModal!: boolean;
  @Getter(CREATE_FORM_ERRORS, StoreNamespace.FORM) public createFormErrors!: string[];
  @Getter(CREATE_FORM_LOADING, StoreNamespace.FORM) public createFormLoading!: boolean;
  @Getter(USER_DETAILS, StoreNamespace.AUTHENTICATION) public userDetails!: UserDetails;
  @Getter(OPEN_POPUP_CHANGES_NOTIFICATION_FLAG, StoreNamespace.LOBBY) public openChangesNotificationFlag!: boolean;
  @Getter(OPEN_CHANGES_NOTIFICATION_MODAL, StoreNamespace.FORM) public openChangesNotificationModal!: boolean;

  public formTaxYear: number = new Date().getFullYear();
  public allowTaxYearList: Array<{ name: string, value: number }> = [];
  public allowTaxYearListLength: number = 1;

  public mounted(): void {
    this.setCreateFormLoading(false);
    this.setCreateFormErrors([]);
    this.allowTaxYearList = [];
    for (const year of this.userDetails.allowTaxYearList) {
      this.allowTaxYearList.push({ name: '' + year, value: year });
    }
    this.formTaxYear = this.allowTaxYearList[0].value;
    this.allowTaxYearListLength = this.allowTaxYearList[0].name === '' + this.$t('choose') ? 2 : 1;
  }

  public closeDialog(): void {
    this.setOpenChooseFormOfficeModal(false);
    this.setCreateFormErrors([]);
  }

  public onUpdateUserOffice(office: any) {
    if (office && office.officeNum) {
      this.updateUserOffice({ officeNum: office.officeNum });
      this.getChangesNotification();
    }
  }

  public onUpdateTaxYear(taxYear: { name: string, value?: number }): void {
    if (taxYear && taxYear.value) {
      this.formTaxYear = taxYear.value;
    }
  }

  public onCreateForm() {
    this.getChangesNotification();
    this.setCreateFormLoading(true);
    this.$validator.validateAll('createForm').then((result: any) => {
      if (!result) {
        this.setCreateFormLoading(false);
        setTimeout(() => {
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        if (this.openChangesNotificationFlag) {
          this.setOpenChangesNotificationModal(true);
        } else if (!this.userDetails.offices) {
          this.reinitAuthenticationToken(this.formTaxYear);
          return;
        } else {
          this.createNewForm(this.formTaxYear);
        }
      }
    });
  }

  public getChangesNotification() {
    this.getChangesNotificationFlag();
  }

  public destroyed() {
    this.setOpenChooseFormOfficeModal(false);
  }

}
